import { SearchBar } from 'components';
import { styled } from 'libs/ui/styled';

export const SearchBarStyled = styled(SearchBar)({
  width: 252,
});
